export default {"src":"/_next/static/media/GOMINING.ae350321.svg","height":28,"width":137,"blurWidth":0,"blurHeight":0};